import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BaseAutoComplete from "components/shared/baseForm/BaseAutoComplete";
import AddEmployeeModal from "components/shared/addEmployeeModal/AddEmployeeModal";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useGetFacilityEmployeesQuery } from "store/apis/OrdersApi";
import { REQUIRED_ERROR } from "utils/errorMessages";

export default function MarketplaceEmployeeOrder({ facilityId }) {
  const { control, watch, setValue, formState: { errors } } = useFormContext();
  const [addOpen, setAddOpen] = useState(false);
  const employeeId = watch("employeeId");

  const { data: employees, isFetching: fetchingEmployees } = useGetFacilityEmployeesQuery(
    facilityId,
    { skip: !facilityId }
  );

  useEffect(() => {
    if (employeeId && employees) {
      const emp = employees.find((e) => e.id === employeeId);
      if (emp) setValue("guestName", emp.label);
    }
  }, [employeeId, employees, setValue]);

  return (
    <Grid container spacing={2} alignItems="flex-start" mt={2} justifyContent="center">
      <Grid size={{ xs: 6 }}>
        <BaseAutoComplete
          options={employees || []}
          control={control}
          loading={fetchingEmployees}
          formSelectProps={{
            props: { name: "employeeId", size: "small" },
            validationProps: { required: REQUIRED_ERROR("Employee") },
          }}
          errors={errors}
          handleSearch={() => {}}
          placeholder="Search or Select Employee"
        />
      </Grid>
      <Grid size={{ xs: 2 }}>
        <Button
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => setAddOpen(true)}
          sx={{ textTransform: "uppercase", borderRadius: "8px", whiteSpace: "nowrap", mt: ".25rem" }}
        >
          Add New
        </Button>
      </Grid>
      <AddEmployeeModal open={addOpen} onSaved={() => setAddOpen(false)} facilityId={facilityId} />
    </Grid>
  );
}
